// extracted by mini-css-extract-plugin
export default {"wrapper":"Winners_wrapper__saPMX","item":"Winners_item__jQSW0","avatarBlock":"Winners_avatarBlock__+ExYe","star":"Winners_star__jmxb4","name":"Winners_name__nvWiV"};